<template>
    <!--添加奖惩-->
    <div>
        <el-dialog :title="operation ? '添加' : (optType?'编辑':'查看')" :visible.sync="dlgVisible" v-model="dlgVisible" :close-on-click-modal="false">
            <el-form ref="dlgFrom" :model="dlgFrom" class="demo-form-inline" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名:" prop="UserName" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" :disabled="true" v-model="dlgFrom.UserName">
                                <el-button slot="append" icon="el-icon-search" @click="chooseUser" v-if="operation"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="display:none;">
                        <el-form-item label="姓名ID:" prop="UserId">
                            <el-input type="text" v-model="dlgFrom.UserId"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公司:" prop="Factory" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.Factory" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="部门:" prop="Dpt" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.Dpt" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="display:none;">
                        <el-form-item label="部门ID:" prop="DptId">
                            <el-input type="text" v-model="dlgFrom.DptId"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="岗位:" prop="Post" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" :disabled="true" v-model="dlgFrom.Post"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="奖惩类型:" prop="Type" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.Type" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="奖励" value="奖励"></el-option>
                                <el-option label="惩罚" value="惩罚"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="奖惩等级:" prop="RewardLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.RewardLevel" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="国家级" value="国家级"></el-option>
                                <el-option label="省级" value="省级"></el-option>
                                <el-option label="市级" value="市级"></el-option>
                                <el-option label="区级" value="区级"></el-option>
                                <el-option label="集团级" value="集团级"></el-option>
                                <el-option label="分公司级" value="分公司级"></el-option>
                                <el-option label="部门级" value="部门级"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.Type == '奖励'">
                    <el-col :span="12">
                        <el-form-item label="奖励类型:" prop="SecondaryRewardType" :rules="[ { required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.SecondaryRewardType" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="现金奖励" value="现金奖励"></el-option>
                                <el-option label="荣誉奖励" value="荣誉奖励"></el-option>
                                <el-option label="晋升奖励" value="晋升奖励"></el-option>
                                <el-option label="标兵" value="标兵"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.Type == '惩罚'">
                    <el-col :span="12">
                        <el-form-item label="惩罚类型:" prop="SecondaryRewardType" :rules="[ { required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.SecondaryRewardType" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="通报处罚" value="通报处罚"></el-option>
                                <el-option label="现金处罚" value="现金处罚"></el-option>
                                <el-option label="降职处罚" value="降职处罚"></el-option>
                                <el-option label="待岗处罚" value="待岗处罚"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType=='现金奖励'||dlgFrom.SecondaryRewardType=='现金处罚'||dlgFrom.SecondaryRewardType=='标兵'">
                    <el-col :span="12">
                        <el-form-item label="金额:" prop="Salary" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.Salary" @blur="inputMoney('Salary')" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行日期:" prop="ExecuteDate" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-date-picker type="date" v-model="dlgFrom.ExecuteDate" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="optDisabled"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行方式:" prop="ExecuteType" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.ExecuteType" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="现金" value="现金"></el-option>
                                <el-option label="工资体现" value="工资体现"></el-option>
                                <el-option label="内购券" value="内购券"></el-option>
                                <el-option label="资金池" value="资金池"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType=='荣誉奖励'">
                    <el-col :span="12">
                        <el-form-item label="荣誉称号:" prop="HonoraryTitle" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.HonoraryTitle" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="颁发单位:" prop="IssuedDepartment" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.IssuedDepartment" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="颁发日期:" prop="ReleaseDate" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-date-picker type="date" v-model="dlgFrom.ReleaseDate" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="optDisabled"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="荣誉等级:" prop="HonoraryLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.HonoraryLevel" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否在公司:" prop="isCompany" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-select v-model="dlgFrom.isCompany" placeholder="请选择" style="width: 100%" :disabled="optDisabled">
                                <el-option label="是" value="true"></el-option>
                                <el-option label="否" value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType=='晋升奖励'">
                    <el-col :span="12">
                        <el-form-item label="晋升前等级:" prop="PromoteLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.PromoteLevel" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="晋升后职级等级:" prop="PromoteLaterLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.PromoteLaterLevel" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行日期:" prop="ExecuteDate" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-date-picker type="date" v-model="dlgFrom.ExecuteDate" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="optDisabled"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType=='通报处罚'">
                    <el-col :span="12">
                        <el-form-item label="时间:" prop="PenaltyDate" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-date-picker type="date" v-model="dlgFrom.PenaltyDate" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="optDisabled"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType=='降职处罚'">
                    <el-col :span="12">
                        <el-form-item label="降职前等级:" prop="DemotionLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.DemotionLevel" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="降职后职级等级:" prop="DemotionLaterLevel" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-input type="text" v-model="dlgFrom.DemotionLaterLevel" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行日期:" prop="ExecuteDate" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },]">
                            <el-date-picker type="date" v-model="dlgFrom.ExecuteDate" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="optDisabled"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="dlgFrom.SecondaryRewardType == '标兵'">
                    <el-col :span="12">
                        <el-form-item label="标兵名称:">
                            <el-input type="text" v-model="dlgFrom.ModelName" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="同步党建:" prop="ModeSync">
                            <el-switch v-model="dlgFrom.ModeSync" active-text="同步" inactive-text="不同步"> </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="标兵描述">
                            <el-input type="textarea" v-model="dlgFrom.ModeRemark" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="标兵图片">
                            <a target="_blank" :href="dlgFrom.ModeUrl">{{dlgFrom.ModeUrlName}}</a>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-button icon="el-icon-search" circle @click="onShowDlg1"></el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="具体描述">
                            <el-input type="textarea" v-model="dlgFrom.Explain" :disabled="optDisabled"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <upload-files :files="dlgFrom.FileArry" :key="key" action="/cyl/ftp/ftp/upload" :limit="20" @fun="dealFiles" :IsDisabled="operation1" :IsDel="operation1"></upload-files>
                <el-row v-if="optType">
                    <el-col :span="24" style="text-align: center">
                        <el-button type="primary" v-on:click="onSubmit('dlgFrom')">提交</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="选择人员" :visible.sync="addUserVisible" v-model="addUserVisible" width="75%" center append-to-body>
            <UserChoose :data="choosedusers" :all="true" :single="false" @callback="usercallFunction"></UserChoose>
        </el-dialog>

        <el-dialog title="图片" :visible.sync="cropperDlgVisible" v-model="cropperDlgVisible" width="1000px" center append-to-body>
            <cropperModal action="https://api.gradgroup.cn/ftp/ftp/upload" @callback="cropperCallFunction"></cropperModal>
        </el-dialog>

    </div>
</template>

<script>
    import util from "../../../util/date";
    import * as validate from "../../../util/validate";
    import UserChoose from "../../components/UserChoose";
    import UploadFiles from "../../components/UploadFiles";
    import cropperModal from "../componentModals/cropperModal";
    import {
        AddRewards,
        UpdateRewards,
        GetUserPostDptOrg,
        GetRewardsDetail,
    } from "../../api/hr";
    export default {
        components: {  UserChoose, UploadFiles ,cropperModal},
        data() {
            return {
                optType: false,   // 编辑/查看
                operation: false, // true:新增, false:编辑
                key: 0,

                dlgVisible: false, // dlg 显示隐藏
                optDisabled:false,
                dlgFrom: {
                    UserId: "",
                    UserName: "",
                    Type: "",
                    IssuedDepartment: "",
                    ExecuteType: "",
                    Salary: "",
                    Explain: "",
                    ExecuteDate: "",
                    FileArry: [],
                    Factory: "",
                    Post: "",
                    Dpt: "",
                    DptId:"",
                },
                cropperDlgVisible: false,
                addUserVisible: false,
                choosedusers: [],
            };
        },
        methods: {
            // 选中一行显示
            onShowDlg(pid) {
                
                if (pid == "" || pid == null) {
                    this.dlgFrom = {
                        UserId: "",
                        UserName: "",
                        Type: "",
                        IssuedDepartment: "",
                        ExecuteType: "",
                        Salary: "",
                        Explain: "",
                        ExecuteDate: "",
                        FileArry: [],
                    };
                    this.key += 1;
                    this.dlgVisible = true;
                }else{
                    GetRewardsDetail({ id: pid }).then((res) => {
                        console.log(res.data)
                        this.dlgFrom = res.data.response;
                        this.key += 1;
                        this.dlgVisible = true;
                    });
                }
            },
            onShowDlg1() {
                this.cropperDlgVisible = true;
            },
            onSubmit(formName) {
                this.$confirm("确定要提交吗？", "提示", {}).then(() => {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            let para = Object.assign({}, this.dlgFrom);
                            if (this.operation && this.optType) {
                                //新增
                                AddRewards(para).then((res) => {
                                    if (res.data.success) {
                                        this.$message({
                                            message: "添加成功",
                                            type: "success",
                                            duration: 5000,
                                        });
                                        this.dlgVisible = false;
                                        this.$emit("callback"); //将值传给父组件
                                    } else {
                                        this.$message({
                                            message: res.data.msg,
                                            type: "error",
                                            duration: 5000,
                                        });
                                        //this.dlgVisible = true;
                                    }
                                });
                            } else if (!this.operation && this.optType) {
                                //修改
                                UpdateRewards(para).then((res) => {
                                    if (res.data.success) {
                                    this.$message({
                                        message: "修改成功",
                                        type: "success",
                                        duration: 5000,
                                    });
                                    this.dlgVisible = false;
                                    this.$emit("callback"); //将值传给父组件
                                    } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                        duration: 5000,
                                    });
                                    }
                                });
                            }
                        } else {
                            this.$message({
                                message: "请检查必填项",
                                type: "error",
                                duration: 5000,
                            });
                            return false;
                        }
                    });
                });
            },
            formatStartTime: function (row, colume) {
                var date = row[colume.property];
                if (date == undefined) {
                    return "";
                }
                return util.formatDate.format(new Date(date), "yyyy-MM-dd");
            },
            cropperCallFunction(newdata) {
                console.log(newdata)
                console.log("cropperCallFunction", newdata);
                console.log("newdata.response.HttpHost", newdata.newdata.data.httpHost);
                this.dlgFrom.ModeUrl = newdata.newdata.data.httpHost + newdata.newdata.data.filePath;
                // this.dlgFrom.ModeUrlName = "标兵图片" + newdata.newdata.data.fileExtension;
                this.dlgFrom.ModeUrlName = this.dlgFrom.Factory + '-' + this.dlgFrom.ModelName + '-' + this.dlgFrom.UserName + newdata.newdata.data.fileExtension;
                console.log(this.dlgFrom)
                this.cropperDlgVisible = false;
            },
            usercallFunction(newdata) {
                if (newdata.length > 1) {
                    this.$message({
                    message: "不允许选择多人",
                    type: "error",
                    });
                    return;
                }
                
                GetUserPostDptOrg({ userId: newdata[0].Id }).then((res) => {
                    if (res.data.success) {
                        console.log(res)
                        this.dlgFrom.UserId = newdata[0].Id;
                        this.dlgFrom.UserName = newdata[0].UserNameClaim;
                        this.dlgFrom.Factory = res.data.response.OrganizationName;
                        this.dlgFrom.Dpt = res.data.response.DepartmentName;
                        this.dlgFrom.DptId = res.data.response.DepartmentId;
                        this.dlgFrom.Post = res.data.response.PostName;
                    } else {
                    this.$message({
                        message: "获取部门信息出错",
                        type: "error",
                        duration: 5000,
                    });
                    }
                });
                this.addUserVisible = false;
                },
            
            inputMoney(name) {
                if (!validate.validateIsMoney(this.dlgFrom[name])) {
                    this.$message({
                        message: "请输入金额",
                        type: "error",
                        duration: 5000,
                    });
                    this.dlgFrom[name] = null;
                    return;
                }
            },

            chooseUser() {
                this.addUserVisible = true;
            },
            
            callFunction(item) {
                this[item.Func].apply(this, item);
            },
            
            
            dealFiles(data) {
                this.dlgFrom.FileArry = data.backData;
            },
        },
        mounted() {
            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            let buttons = window.localStorage.buttList
                ? JSON.parse(window.localStorage.buttList)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers, buttons);
        },
    };
</script>

<style scoped>
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
</style>